<kendo-dropdownlist
   fxFill
   class="sam-margin-left"
   [data]="items$ | async"
   [textField]="'value'"
   [valueField]="'value'"
   [valuePrimitive]="false"
   (selectionChange)="selectionChange($event)"
>
   <ng-template kendoDropDownListValueTemplate let-dataItem>
      <p [innerHtml]="dataItem?.title | safeHtml"></p>
   </ng-template>
   <ng-template kendoDropDownListItemTemplate let-dataItem>
      <p [innerHtml]="dataItem?.title | safeHtml"></p>
   </ng-template>
</kendo-dropdownlist>
